//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function buildQueryString(values) {
  const params = new URLSearchParams();
  Object.entries(values || {}).forEach(([key, val]) => {
    if (val !== null && val !== undefined && val !== "") {
      params.append(key, val);
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

function MilestoneTracking() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-milestone-tracking?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-milestone-tracking/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function Export(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/unlock-milestone-tracking/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 async function updateAutoRedemptionFlagAPI(values) {
     try {
       const obj = {
         method: "PUT",
         credentials: 'include',
         headers: {
           "Content-Type": "application/json"          
         },
         body: JSON.stringify(values),
       };
       let res = await fetch(`${config.host}/cdr-panel/unlock-milestone-tracking`, obj);
       return handleResponse(res);
     } 
     catch (err) {
       handleError(err);
     }
   }
    async function createShipto(values) {
       try {
         const obj = {
           method: "POST",
           credentials: 'include',
           headers: {
             "Content-Type": "application/json"          
           },
           body: JSON.stringify(values),
         };
         let res = await fetch(`${config.host}/cdr-panel/unlock-milestone-tracking`, obj);
         return handleResponse(res);
       } catch (err) {
         handleError(err);
       }
     }
    async function uploadUnlockShipto(values) {
        try {
          const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };
          let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management/uploadUnlockShipto`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }
    
      async function shiptomilestoneView(values) {
       try {
         const obj = {
           method: "POST",
           credentials: 'include',
           headers: {
             "Content-Type": "application/json"          
           },
           body: JSON.stringify(values),
         };
         let res = await fetch(`${config.host}/cdr-panel/unlock-milestone-tracking/shiptoMilestoneView`, obj);
         return handleResponse(res);
       } catch (err) {
         handleError(err);
       }
     }

    async function getMilestoneConfig (values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-milestone-tracking/getMilestoneConfig`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getQualifyingTransactions(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/unlock-milestone-tracking/getQualifyingTransactions`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 async function getQualifyingTransactionLines (values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-milestone-tracking/getQualifyingTransactionLines${buildQueryString(values)}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function downloadQualifyingTransactions (values) {
    try {
      const res = await fetch(
        `${config.host}/cdr-panel/unlock-milestone-tracking/downloadQualifyingTransactions${buildQueryString(values)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      if (!res.ok) {
        throw new Error(`Download failed with status ${res.status}`);
      }
      return await res.blob();
    } catch (err) {
      handleError(err);
      throw err;
    }
  }
  return {
    getAPI,
    searchAPI,
    Export,
    updateAutoRedemptionFlagAPI,
    createShipto,
    uploadUnlockShipto,
    shiptomilestoneView,
    getMilestoneConfig ,
    getQualifyingTransactions,
    getQualifyingTransactionLines,
    downloadQualifyingTransactions
  };

}

export default MilestoneTracking;